<template>
  <div class="filter-container">
    <el-row :gutter="10">
      <search-input
        v-if="showExSearch.defFilterByBranch"
        type="remoteSelect"
        :base="base"
        :searchText="$t('api.' + base + '.search')"
        :fetchList="fetchBranchList"
        :srchFilter="branchFilter"
        name="branch_name"
        selectIdField="bid"
        selectNameField="name"
        :labelArr="['name', 'bid']"
        param="bid"
        clearable
      >
      </search-input>
      <search-input
        v-else
        :base="base"
        :searchText="searchText"
        name="search"
        param="query"
        >
      </search-input>
      <search-input
        v-if="showExSearch.filterByMember"
        type="remoteSelect"
        :base="base"
        :searchText="$t('api.member.filter')"
        :fetchList="fetchMemberList"
        :srchFilter="memberFilter"
        name="email"
        selectIdField="uid"
        selectNameField="email"
        :labelArr="['uid', 'email']"
        param="uid"
        clearable
        >
      </search-input>
      <search-input
        v-if="showExSearch.filterByRegionID"
        type="select"
        base="orders"
        name="region_name"
        param="region_id"
        selectStore="Region"
        :list="getRegionListWithBrand()"
        :searchText="$t('api.filter.region.label')"
        :colWidth="regionWidth"
        clearable
        >
      </search-input>
      <search-input
        v-if="showExSearch.filterBySaleRegionID"
        type="select"
        base="orders"
        name="sale_region_name"
        param="sale_region_id"
        selectStore="Region"
        :list="getRegionListWithBrand()"
        :searchText="$t('api.filter.saleRegion.label')"
        :colWidth="saleRegionWidth"
        clearable
      >
      </search-input>
      <search-input
        v-if="showExSearch.filterBySttmID"
        base="statementOrders"
        name="statement_id"
        param="statement_id"
        clearable
        >
      </search-input>
      <search-input
        v-if="showExSearch.filterByBrandID"
        type="select"
        base="payment_brand"
        name="brand_name"
        param="brand_id"
        selectStore="Brand"
        :list="$store.getters.brandList"
        :searchText="$t('api.brand.name')"
        :colWidth="brandWidth"
        clearable
        >
      </search-input>
      <search-input
        v-if="showExSearch.filterBySOADocumentID"
        :base="base"
        name="doc_id"
        param="doc_id"
        clearable
        >
      </search-input>
      <search-input
        v-if="showExSearch.filterByIncapable"
        type="checkbox"
        :base="base"
        name="incapable"
        param="incapable"
        :searchText="$t('api.orders.refundComp.listIncapable')"
        :colWidth="4"
        >
      </search-input>
      <search-input
        v-if="showExSearch.filterByPhone"
        base="user"
        name="phone"
        param="phone"
        >
      </search-input>
      <search-input
        v-if="showExSearch.filterBySOADocumentNumber"
        :base="base"
        name="number"
        param="number"
        >
      </search-input>
      <el-col :xs="8" :md="enableAdvSrch ? 4 : 1">
        <el-button-group v-if="enableAdvSrch">
          <el-button
            @click="showAdvSrch"
            :type="hasAdvSrch ? 'primary' : 'default'"
            :disabled="!enableAdvSrch"
            icon="el-icon-search"
            class="action list"
            plain
            >
            {{ $t('api.advSrch.btn') }}
          </el-button>
          <el-button
            v-if="hasAdvSrch"
            @click="clearAdvSrch"
            icon="el-icon-delete"
            class="action list"
            plain
            >
          </el-button>
        </el-button-group>
        <el-tooltip
          class="item"
          effect="dark"
          placement="top"
          :content="refreshText"
          >
          <el-button
            @click="renewList"
            icon="el-icon-refresh"
            class="action list refresh"
            plain
            >
          </el-button>
        </el-tooltip>
      </el-col>
      <el-col :xs="24" :md="actionCols"
        class="right action-btns">
        <slot
          v-if="hasListAction"
          name="acts"
          act
          >
        </slot>
        <el-button
          v-if="hasCreate"
          class="action"
          type="primary"
          icon="el-icon-plus"
          @click.native="clickToCreate"
          >
          {{ getLabelText(base, 'create') }}
        </el-button>
      </el-col>
    </el-row>
    <el-row :gutter="10" v-if="showExSearch.display">
      <search-input
        v-if="showExSearch.filterByID"
        :base="base"
        name="id"
        :param="idField"
      >
      </search-input>
      <slot name="exsrch" srch></slot>
      <search-input
        v-if="showExSearch.filterByAuthID"
        base="user"
        name="auth_id"
        param="auth_id"
      >
      </search-input>
      <search-input
        v-if="showExSearch.filterByDateRange"
        :base="base"
        :name="dateRangeName"
        :allowNames="allowDateNames"
        param="date_range"
        type="dateRange"
        :updListQuery="updListQuery"
        ref="dateRangeFilter"
      >
      </search-input>
    </el-row>
    <el-row :gutter="10">
      <el-col
        :xs="24"
        v-if="filterTags.length > 0"
        >
        <el-tag
          class="filter-item"
          v-for="item in filterTags"
          :key="item.idName + '.' + item.idValue"
          @close="handleClose(item)"
          closable
          >
          {{ item.key ? $t(item.key) : item.name }}: {{ item.value }}
        </el-tag>
        &nbsp;
      </el-col>
    </el-row>
    <el-dialog
      :title="$t('api.advSrch.btn')"
      :visible.sync="srchDialogVisible"
      :before-close="closeAdvSrch"
      custom-class="srch-dialog rwd-dialog"
      >
      <el-form>
        <el-form-item
          v-for="(cond, index) in queryConds"
          :key="cond.key"
          >
          <el-row :gutter="10">
            <el-col :xs="16" :md="3">
              <el-select
                v-if="index > 0"
                v-model="cond.op"
                >
                <el-option
                  v-for="item in ops"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  >
                </el-option>
              </el-select>
              <div v-else>&nbsp;</div>
            </el-col>
            <el-col :xs="16" :md="7">
              <el-select
                v-model="cond.field"
                :placeholder="$t('api.advSrch.field')"
                @change="(v) => fieldChange(v, index)"
                filterable
                >
                <el-option
                  v-for="(f, idx) in fields"
                  :key="idx"
                  :label="f.label"
                  :value="idx"
                  >
                </el-option>
              </el-select>
            </el-col>
            <el-col :xs="16" :md="3">
              <el-select
                v-if="cond.type === 'enum'"
                v-model="cond.comp"
                >
                <el-option
                  v-for="item in enumComps"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  >
                </el-option>
              </el-select>
              <el-select
                v-else
                v-model="cond.comp"
                >
                <el-option
                  v-for="item in comps"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  >
                </el-option>
              </el-select>
            </el-col>
            <el-col :xs="16" :md="8">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top-start"
                :open-delay="500"
                :content="advSrchPlaceholder(cond.type)"
                >
                <div>
                  <el-select
                    v-if="cond.type === 'enum'"
                    v-model="cond.value"
                    :placeholder="advSrchPlaceholder(cond.type)"
                    multiple
                    filterable
                    clearable
                    >
                    <el-option
                      v-for="item in cond.opts"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      >
                    </el-option>
                  </el-select>
                  <el-date-picker
                    v-else-if="cond.type === 'datetime'"
                    v-model="cond.value"
                    type="datetime"
                    :placeholder="advSrchPlaceholder(cond.type)"
                    default-time="00:00:00"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    >
                  </el-date-picker>
                  <el-date-picker
                    v-else-if="cond.type === 'date'"
                    v-model="cond.value"
                    type="date"
                    :placeholder="advSrchPlaceholder(cond.type)"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    >
                  </el-date-picker>
                  <el-date-picker
                    v-else-if="cond.type === 'month'"
                    v-model="cond.value"
                    type="date"
                    :placeholder="advSrchPlaceholder(cond.type)"
                    format="yyyy-MM"
                    value-format="yyyy-MM-01"
                    >
                  </el-date-picker>
                  <el-input
                    v-else
                    v-model="cond.value"
                    :placeholder="advSrchPlaceholder(cond.type)"
                    @keypress.enter.native.prevent="searchConds"
                    clearable
                    >
                  </el-input>
                </div>
              </el-tooltip>
            </el-col>
            <el-col
              :xs="16"
              :md="3"
              class="adv-rules-button nomargin"
              >
              <el-button
                @click="addCond(index)"
                type="primary"
                icon="el-icon-plus"
                circle
                >
              </el-button>
              <el-button
                v-if="queryConds.length > 1"
                @click="minusCond(index)"
                type="danger"
                icon="el-icon-minus"
                circle
                >
              </el-button>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <el-card
        v-if="filters.length > 0"
        class="box-card filter-text"
        >
        <div slot="header">
          {{ $t('api.advSrch.filteredConds.title') }}
          <el-popover
            placement="top"
            trigger="hover"
            transition="none"
            :open-delay="100"
            :tabindex="-1"
            >
            <div
              class="form-item-readme-content"
              >
              {{ $t('api.advSrch.filteredConds.desc') }}
            </div>
            <el-link
              slot="reference"
              class="form-item-readme-link"
              icon="el-icon-question"
              :underline="false"
              type="warning"
              >
            </el-link>
          </el-popover>
        </div>
        <div
          v-for="(f, idx) in filters"
          :key="idx"
          >
          - <b>{{ getLabelText(base, f.field) }}</b>: {{ f.value }}
        </div>
      </el-card>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="closeAdvSrch"
          >
          {{ $t('api.cancelBtn') }}
        </el-button>
        <el-button
          @click="resetConds"
          type="warning"
          plain
          >
          {{ $t('api.resetBtn') }}
        </el-button>
        <el-button
          type="primary"
          :disabled="isNoConds"
          @click="searchConds"
          >
          {{ $t('api.searchBtn') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import _ from 'lodash'
import { fetchList as fetchBranchList } from '@/api/merchant/branch'
import { fetchList as fetchUserList } from '@/api/user/user'
import { getOptMap, getLabelText } from '@/utils/i18n'
import { branchFilter, memberFilter, parseField } from '@/utils/filter'
import { getDateRange, getDateTimeFormat, getTimeText } from '@/utils/time'
import { updateRoute } from '@/utils/route'
import {
  ProductSalesMode
} from '@/enums'

const defQueryConds = [
  {
    field: '',
    op: 'and',
    comp: 'eq'
  },
  {
    field: '',
    op: 'and',
    comp: 'eq'
  },
  {
    field: '',
    op: 'and',
    comp: 'eq'
  }
]

const defOps = [
  {
    label: 'AND',
    value: 'and'
  },
  {
    label: 'OR',
    value: 'or'
  }
]

const defComps = [
  {
    label: '=',
    value: 'eq'
  },
  {
    label: '!=',
    value: 'ne'
  },
  {
    label: '>',
    value: 'gt'
  },
  {
    label: '≥',
    value: 'gte'
  },
  {
    label: '<',
    value: 'lt'
  },
  {
    label: '≤',
    value: 'lte'
  }
]

const defEnumComps = [
  {
    label: '=',
    value: 'in'
  },
  {
    label: '!=',
    value: 'nin'
  }
]

export default {
  name: 'list-filter',
  props: {
    base: {
      type: String,
      required: true
    },
    idField: {
      type: String,
      default: 'id'
    },
    searchText: {
      type: String
    },
    showExSearch: {
      type: Object,
      default: () => ({
        display: true,
        defFilterByBranch: false,
        filterByID: true,
        filterByMember: false,
        filterByAuthID: false,
        filterByPhone: false,
        filterByRegionID: false,
        filterBySttmID: false,
        filterByBrandID: false,
        filterByIncapable: false,
        filterByDateRange: false,
        filterByReviewDescription: false,
        filterBySOADocumentNumber: false
      })
    },
    dateRangeName: {
      type: String,
      default: 'created_at'
    },
    hasListAction: {
      type: Boolean,
      default: true
    },
    hasCreate: {
      type: Boolean,
      default: true
    },
    enableAdvSrch: {
      type: Boolean,
      default: false
    },
    isBrandField: {
      type: Boolean,
      default: false
    },
    srchFields: {
      type: Array,
      default: () => ['name']
    },
    filterCols: {
      type: Array,
      default: () => ['id']
    },
    optionCols: {
      type: Array,
      default: () => []
    },
    allowDateNames: {
      type: Array,
      default: () => []
    },
    clickCreate: {
      type: Function,
      required: false
    },
    fetchFields: {
      type: Function,
      required: false
    },
    refreshList: {
      type: Function,
      required: false
    },
    getFilters: {
      type: Function,
      required: false
    },
    updListQuery: {
      type: Function,
      required: false
    }
  },
  data () {
    return {
      ops: JSON.parse(JSON.stringify(defOps)),
      comps: JSON.parse(JSON.stringify(defComps)),
      enumComps: JSON.parse(JSON.stringify(defEnumComps)),
      queryConds: JSON.parse(JSON.stringify(defQueryConds)),
      savedConds: null,
      srchDialogVisible: false,
      hasAdvSrch: false,
      formLabelWidth: '120px',
      branchFilter: branchFilter,
      memberFilter: memberFilter,
      fields: [],
      filter: {},
      filters: {},
      filterTags: []
    }
  },
  created () {
  },
  mounted () {
    this.updateList()
  },
  computed: {
    regionWidth () {
      let w = 4
      if (this.showExSearch.filterByBrandID) {
        w -= 1
      }
      if (this.showExSearch.filterBySaleRegionID) {
        w -= 1
      }
      if (w < 4 && !this.enableAdvSrch) {
        w += 1
      }
      return w
    },
    saleRegionWidth () {
      let w = 4
      if (this.showExSearch.filterByBrandID) {
        w -= 1
      }
      if (this.showExSearch.filterByRegionID) {
        w -= 1
      }
      if (w < 4 && !this.enableAdvSrch) {
        w += 1
      }
      return w
    },
    brandWidth () {
      let w = 4
      if (this.showExSearch.filterByRegionID) {
        w = 3
      }
      return w
    },
    actionCols () {
      let cols = 19
      if (this.showExSearch.filterByRegionID) {
        cols -= this.regionWidth
      }
      if (this.showExSearch.filterBySaleRegionID) {
        cols -= this.saleRegionWidth
      }
      if (this.showExSearch.filterByBrandID) {
        cols -= this.brandWidth
      }
      if (this.showExSearch.filterBySttmID) {
        cols -= 4
      }
      if (this.showExSearch.filterBySOADocumentID) {
        cols -= 4
      }
      if (this.showExSearch.filterBySOADocumentNumber) {
        cols -= 4
      }
      if (this.enableAdvSrch) {
        cols -= 3
      }
      return cols
    },
    isNoConds () {
      let res = true
      this.queryConds.every((ele) => {
        if (ele.field !== '') {
          let v = ele.value
          switch (ele.type) {
            case 'enum':
              if (Array.isArray(v) && v.length > 0) {
                res = false
              }
              break
            case 'integer':
            case 'float':
            case 'datetime':
            case 'month':
            case 'date':
              if (v !== '') {
                res = false
              }
              break
            case 'string':
              res = false
              break
          }
          if (res === false) {
            return false
          }
        }
        return true
      })
      return res
    },
    refreshText () {
      return this.$t('api.refreshList')
    }
  },
  watch: {
    '$route.query' (v) {
      this.updateList()
    }
  },
  methods: {
    parseField,
    fetchBranchList,
    getLabelText,
    getOptMap,
    updateRoute,
    fetchUserList,
    getDateRange,
    getDateTimeFormat,
    getTimeText,
    getRegionListWithBrand () {
      let regionList = JSON.parse(JSON.stringify(this.$store.getters.regionList))
      for (const i in regionList) {
        regionList[i].name = regionList[i].name + ' (' + regionList[i].brand_name + ')'
      }

      return regionList
    },
    advSrchPlaceholder (t) {
      t = t || 'string'
      return this.$t('api.advSrch.placeholder.' + t)
    },
    fetchMemberList (query) {
      return fetchUserList(query, 'member')
    },
    setFields (data) {
      this.fields.splice(0, this.fields.length)
      for (let i = 0; i < data.length; ++i) {
        this.fields.push(Object.assign({}, data[i], {
          label: this.getLabelText(this.base, data[i].name)
        }))
      }
    },
    renewList () {
      if (this.$refs.dateRangeFilter) {
        this.$refs.dateRangeFilter.updDateRangeFilter()
        this.updateDateRange()
      }
      this.refreshList()
    },
    updateList () {
      this.updateQuery()
      this.updateTags()
      this.refreshList()
    },
    updateQuery () {
      this.updateBasicQuery()
      this.updateFilters()
      this.updateDateRange()
      this.updateOptions()
      if (typeof this.$route.query.advsrch !== 'undefined') {
        this.queryConds = JSON.parse(this.$route.query.advsrch)
        this.updListQuery('advsrch', this.genAdvFilter())
        this.hasAdvSrch = true
      } else {
        this.clearConds()
      }
    },
    updateBasicQuery () {
      let query = this.$route.query.query
      let filter = ''
      if (query && query !== '') {
        let fields = []
        this.srchFields.forEach((v) => {
          let obj = {}
          switch (v) {
            case 'email':
            case 'auth_id':
              obj[v] = query + '%'
              break
            default:
              obj[v] = '%' + query + '%'
              break
          }
          fields.push(obj)
        })
        if (fields.length === 1) {
          filter = JSON.stringify(fields[0])
        } else if (fields.length > 1) {
          filter = '{$or:' + JSON.stringify(fields) + '}'
        }
      }
      this.updListQuery('query', filter)
    },
    updateFilters () {
      for (let i = 0; i < this.filterCols.length; ++i) {
        const f = this.filterCols[i]
        const q = this.$route.query[f.name]
        switch (f.type) {
          case String:
            if (f.fuzzy === true && q) {
              this.filter[f.name] = `%${q}%`
            } else {
              this.filter[f.name] = q
            }
            break
          case 'custom':
            if (f.filter) {
              if (q) {
                const qf = JSON.stringify(f.filter).replace(/{query}/g, q)
                this.updListQuery(f.name, qf)
              } else {
                this.updListQuery(f.name, null)
              }
            }
            break
          default:
            let name = f.name || f
            let filterCol = f
            if (f.column) {
              filterCol = f.column
              if (this.filter[filterCol]) {
                continue
              }
            }
            let n = parseInt(this.$route.query[name])
            this.filter[filterCol] = isNaN(n) ? null : n
            break
        }
      }
      this.updListQuery('default', this.filter)
    },
    updateDateRange () {
      if (!this.$refs.dateRangeFilter) {
        return
      }
      let dateName = this.$route.query.date_name || this.dateRangeName
      let dateRange = this.getDateRange()
      let filter = ''
      let obj = {}
      let farr = this.parseField(this.base, dateName)
      if (Array.isArray(dateRange) &&
        dateRange.length === 2
      ) {
        let field = farr[1]
        filter = '{$and:[{' +
          field + ':{$gte:"' +
          this.getDateTimeFormat(dateRange[0], true) + '"}},{' +
          field + ':{$lte:"' +
          this.getDateTimeFormat(dateRange[1], true) + '"}}]}'
        obj = {
          field: field,
          value: this.getTimeText(dateRange[0]) +
          ' ~ ' +
          this.getTimeText(dateRange[1])
        }
      }
      this.updListQuery('date_range', filter, obj)
    },
    updateOptions () {
      for (let i = 0; i < this.optionCols.length; ++i) {
        let filter = ''
        let ftype = ''
        let f = this.optionCols[i]
        if (typeof f === 'object') {
          ftype = f.type
          f = f.name
        } else if (f === 'trans_status') {
          ftype = 'trans'
        }
        let q = this.$route.query[f]
        if (typeof q !== 'undefined') {
          let fields = []
          let arr = q.split(',')
          let l = arr.length
          for (let j = 0; j < l; j++) {
            let obj = {}
            switch (ftype) {
              case 'trans':
                let sarr = arr[j].split('-')
                let tobj = {
                  trans_status: sarr[1]
                }
                if (sarr[1] === '0') {
                  tobj = {
                    $or: [
                      {
                        trans_status: sarr[1]
                      },
                      {
                        trans_status: null
                      }
                    ]
                  }
                }
                obj.$and = [
                  {
                    lang_id: sarr[0]
                  },
                  tobj
                ]
                break
              case 'date':
                switch (q) {
                  case 'exists':
                    obj[f] = {
                      '$gt': '0000-00-00'
                    }
                    break
                  case 'null':
                    obj[f] = null
                    break
                }
                break
              case 'redeem_status':
                let now = this.getDateTimeFormat(this.$moment(), true)
                switch (q) {
                  case 'redeemed':
                    obj.$or = [
                      { used_time: { $gt: '0000-00-00' } },
                      { $and: [
                        { booking_time: { $lte: now } },
                        { sales_mode: ProductSalesMode.Movie }
                      ]}
                    ]
                    break
                  case 'unredeemed':
                    obj.$or = [
                      { $and: [
                        { used_time: null },
                        { sales_mode: { $ne: ProductSalesMode.Movie } }
                      ]},
                      { $and: [
                        { booking_time: { $gt: now } },
                        { sales_mode: ProductSalesMode.Movie }
                      ]}
                    ]
                    obj.no_show_at = null
                    break
                  case 'no_show':
                    obj.no_show_at = { $gt: '0000-00-00' }
                }
                break
              case String:
                obj[f] = arr[j]
                break
              default:
                obj[f] = parseInt(arr[j], 10)
                break
            }
            fields.push(obj)
          }
          if (ftype === 'trans') {
            filter = '{$or:' + JSON.stringify(fields) + '}'
          } else {
            if (fields.length === 1) {
              filter = JSON.stringify(fields[0])
            } else if (fields.length > 1) {
              let obj = {}
              obj[f] = {
                '$in': fields.map((e) => {
                  return e[f]
                })
              }
              filter = JSON.stringify(obj)
            }
          }
        }
        this.updListQuery(f, filter)
      }
    },
    updateTags () {
      this.filterTags.splice(0, this.filterTags.length)
      if (typeof this.filter.region_id !== 'undefined') {
        this.filterTags.push({
          type: 'region',
          key: 'api.filter.region.label',
          value: this.$route.query.region_name || this.$route.query.region_id,
          idName: 'region_id',
          showName: 'region_name',
          idValue: this.filter.region_id
        })
      }
      if (typeof this.filter.sale_region_id !== 'undefined') {
        this.filterTags.push({
          type: 'region',
          key: 'api.filter.saleRegion.label',
          value: this.$route.query.sale_region_name || this.$route.query.sale_region_id,
          idName: 'sale_region_id',
          showName: 'sale_region_name',
          idValue: this.filter.sale_region_id
        })
      }
      if (this.filter.merchant_id) {
        this.filterTags.push({
          type: 'merchant',
          key: 'api.merchant.name',
          value: this.$route.query.merchant_name,
          idName: 'merchant_id',
          showName: 'merchant_name',
          idValue: this.filter.merchant_id
        })
      }
      if (this.filter.bid) {
        this.filterTags.push({
          type: 'branch',
          key: 'api.branch.name',
          value: this.$route.query.branch_name || this.$route.query.bid,
          idName: 'bid',
          showName: 'branch_name',
          idValue: this.filter.bid
        })
      }
      if (this.filter.product_id) {
        this.filterTags.push({
          type: 'product',
          key: 'api.product.name',
          value: this.$route.query.product_name || this.$route.query.product_id,
          idName: 'product_id',
          showName: 'product_name',
          idValue: this.filter.product_id
        })
      }
      if (this.filter.sales_mode) {
        this.filterTags.push({
          type: 'product',
          key: 'api.optFields.salesMode.label',
          value: this.$route.query.sales_mode_name || this.$route.query.sales_mode,
          idName: 'sales_mode',
          showName: 'sales_mode_name',
          idValue: this.filter.sales_mode
        })
      }
      if (this.filter.role_id) {
        this.filterTags.push({
          type: 'role',
          key: 'api.adminRole.name',
          value: this.$route.query.role_name || this.$route.query.role_id,
          idName: 'role_id',
          showName: 'role_name',
          idValue: this.filter.role_id
        })
      }
      if (this.filter.tag_id) {
        this.filterTags.push({
          type: 'tag',
          key: 'api.prodtag.name',
          value: this.$route.query.tag_name || this.$route.query.tag_id,
          idName: 'tag_id',
          showName: 'tag_name',
          idValue: this.filter.tag_id
        })
      }
      if (this.filter.blog_country_id) {
        this.filterTags.push({
          type: 'country',
          key: 'route.blog_country.name',
          value: this.$route.query.blog_country_name || this.$route.query.blog_country_id,
          idName: 'blog_country_id',
          showName: 'blog_country_name',
          idValue: this.filter.blog_country_id
        })
      }
      if (this.filter.country_id) {
        this.filterTags.push({
          type: 'country',
          key: 'route.blog_country.name',
          value: this.$route.query.country_name || this.$route.query.country_id,
          idName: 'country_id',
          showName: 'country_name',
          idValue: this.filter.country_id
        })
      }
      if (this.filter.category_id) {
        this.filterTags.push({
          type: 'category',
          key: 'api.blog.fields.category.label',
          value: this.$route.query.category_name || this.$route.query.category_id,
          idName: 'category_id',
          showName: 'category_name',
          idValue: this.filter.category_id
        })
      }
      if (this.filter.author_id) {
        this.filterTags.push({
          type: 'author',
          key: 'api.blog.fields.author.label',
          value: this.$route.query.author_name || this.$route.query.author_id,
          idName: 'author_id',
          showName: 'author_name',
          idValue: this.filter.author_id
        })
      }
      if (this.filter.brand_id) {
        this.filterTags.push({
          type: 'brand',
          key: 'api.brand.name',
          value: this.$route.query.brand_name,
          idName: 'brand_id',
          showName: 'brand_name',
          idValue: this.filter.brand_id
        })
      }
      if (this.filter.partner_id) {
        this.filterTags.push({
          type: 'partner',
          key: 'api.partner.name',
          value: this.$route.query.partner_name,
          idName: 'partner_id',
          showName: 'partner_name',
          idValue: this.filter.partner_id
        })
      }
      if (this.filter.parent_id) {
        this.filterTags.push({
          type: 'help',
          key: 'api.help.main_item',
          value: this.$route.query.parent_title || this.$route.query.parent_id,
          idName: 'parent_id',
          showName: 'parent_title',
          idValue: this.filter.parent_id
        })
      }
      if (this.filter.lang_id !== undefined) {
        this.$store.dispatch('InitLanguage', this).then(() => {
          this.filterTags.push({
            type: 'lang',
            key: 'api.language.name',
            value: this.$store.getters.languageList[this.$route.query.lang_id].code,
            idName: 'lang_id',
            idValue: this.filter.lang_id
          })
        })
      }
      if (this.filter.id) {
        if (this.$route.query.id) {
          this.filterTags.push({
            type: 'id',
            name: 'ID',
            value: this.$route.query.id,
            idName: 'id',
            idValue: this.filter.id
          })
          return
        }
        if (this.$route.query.orders_id && this.$route.query.description) {
          this.filterTags.push({
            type: 'id',
            name: 'ID',
            value: this.$route.query.orders_id,
            idName: 'orders_id',
            showName: 'description',
            idValue: this.filter.id
          })
        }
      }
      if (this.filter.uid) {
        this.filterTags.push({
          type: 'uid',
          name: 'UID',
          value: this.$route.query.uid,
          idName: 'uid',
          idValue: this.filter.uid
        })
      }
      if (this.filter.member_funbook_id) {
        this.filterTags.push({
          type: 'uid',
          name: 'FunBook UID',
          value: this.$route.query.member_funbook_id,
          idName: 'member_funbook_id',
          idValue: this.filter.member_funbook_id
        })
      }
      if (this.filter.rg_id) {
        this.filterTags.push({
          type: 'resource_group',
          key: 'api.resource_group.name',
          value: this.$route.query.rg_name || this.$route.query.rg_id,
          idName: 'rg_id',
          showName: 'rg_name',
          idValue: this.filter.rg_id
        })
      }
      if (this.filter.group_id) {
        this.filterTags.push({
          type: 'pordtag_group',
          key: 'api.prodtag_group.name',
          value: this.$route.query.group_name,
          idName: 'group_id',
          showName: 'group_name',
          idValue: this.filter.group_id,
          showType: 'group_type',
          typeValue: this.$route.query.group_type
        })
      }
    },
    handleClose (item) {
      this.filterTags.splice(this.filterTags.indexOf(item), 1)
      var query = JSON.parse(JSON.stringify(this.$route.query))
      delete query[item.idName]
      delete query[item.showName]
      this.$router.replace({ query: query })
    },
    addCond (index) {
      this.queryConds.splice(index + 1, 0,
        Object.assign({}, this.queryConds[index], {value: ''})
      )
    },
    minusCond (index) {
      this.queryConds.splice(index, 1)
    },
    resetConds () {
      this.queryConds = JSON.parse(JSON.stringify(defQueryConds))
    },
    genAdvFilter () {
      let filter = ''
      this.queryConds.every((ele) => {
        let v = ele.value
        let name = ele.name
        let comp = ele.comp
        if (
          typeof name !== 'undefined' &&
          typeof v !== 'undefined' &&
          !(Array.isArray(v) && v.length === 0)
        ) {
          let obj = {}
          switch (ele.type) {
            case 'enum':
              break
            case 'integer':
              let arr = v.split(',')
              if (arr.length > 1) {
                let rarr = []
                for (let i = 0; i < arr.length; ++i) {
                  let s = parseInt(arr[i], 10)
                  rarr.push(s)
                }
                v = rarr
                comp = this.getTypeComp(ele.type, 'enum', comp) // Convert type to enum to support csv format
              } else {
                v = parseInt(v, 10)
                if (isNaN(v)) {
                  return false
                }
              }
              break
            case 'float':
              v = parseFloat(v)
              if (isNaN(v)) {
                return false
              }
              break
            case 'datetime':
              v = this.getDateTimeFormat(v, true)
              break
          }
          switch (comp) {
            case 'eq':
              obj[name] = v
              break
            default: // ne, gt, gte, lt, lte, in, nin
              obj[name] = {
                ['$' + comp]: v
              }
              break
          }
          if (filter === '') {
            filter = JSON.stringify(obj)
          } else {
            filter = '{$' + ele.op + ':[' + JSON.stringify(obj) + ',' + filter + ']}'
          }
        }
        return true
      })
      return filter
    },
    closeAdvSrch (done) {
      if (JSON.stringify(this.queryConds) !==
        JSON.stringify(this.savedConds)
      ) {
        this.$confirm(
          this.$t('api.advSrch.confirmClose.message'),
          this.$t('api.advSrch.confirmClose.title'), {
            confirmButtonText: this.$t('api.confirmBtn'),
            cancelButtonText: this.$t('api.cancelBtn'),
            confirmButtonClass: 'el-button--danger',
            type: 'warning',
            dangerouslyUseHTMLString: true
          }).then(() => {
          this.queryConds = JSON.parse(JSON.stringify(this.savedConds))
          this.srchDialogVisible = false
          if (typeof done === 'function') {
            done()
          }
        })
      } else {
        this.srchDialogVisible = false
        if (typeof done === 'function') {
          done()
        }
      }
    },
    showAdvSrch () {
      this.fetchFields().then(res => {
        this.setFields(res.data)
        this.filters = this.getFilters()
        this.savedConds = JSON.parse(JSON.stringify(this.queryConds))
        this.srchDialogVisible = true
      }).catch(error => {
        console.log(error)
      })
    },
    searchConds () {
      this.hasAdvSrch = true
      this.srchDialogVisible = false
      this.updateRoute('advsrch', JSON.stringify(this.queryConds))
    },
    clearConds () {
      this.queryConds = JSON.parse(JSON.stringify(defQueryConds))
      this.updListQuery('advsrch', {})
      this.hasAdvSrch = false
    },
    clearAdvSrch () {
      this.clearConds()
      let q = JSON.parse(JSON.stringify(this.$route.query))
      delete q.advsrch
      this.$router.replace({query: q})
    },
    getTypeComp (oriType, newType, comp) {
      if (oriType === newType) {
        return comp
      }
      if (newType === 'enum') {
        switch (comp) {
          case 'ne':
            return 'nin'
          case 'eq':
          default:
            return 'in'
        }
      } else if (oriType === 'enum') {
        switch (comp) {
          case 'nin':
            return 'ne'
          case 'in':
          default:
            return 'eq'
        }
      }
      return null
    },
    fieldChange (v, idx) {
      this.$set(this.queryConds[idx], 'name', this.fields[v].name)
      let comp = this.getTypeComp(this.queryConds[idx].type, this.fields[v].type, this.fields[v].comp)
      if (comp) {
        this.$set(this.queryConds[idx], 'comp', comp)
      }
      this.$set(this.queryConds[idx], 'type', this.fields[v].type)
      this.$set(this.queryConds[idx], 'value', '')

      let key = this.fields[v].name
      if (this.isBrandField) {
        let id = 2
        this.$store.dispatch('InitBrandField', id).then(() => {
          let bkey = _.upperFirst(_.camelCase(key))
          let bfield = this.$store.getters.brandField[id][bkey]
          if (typeof bfield !== 'undefined') {
            this.$set(this.queryConds[idx], 'opts', bfield.arr)
          } else {
            this.$set(this.queryConds[idx], 'opts', this.getOptMap(this.$t, key))
          }
        })
      } else {
        this.$set(this.queryConds[idx], 'opts', this.getOptMap(this.$t, key))
      }
    },
    clickToCreate () {
      if (this.clickCreate) {
        this.clickCreate()
        return
      }

      this.$router.push({
        path: this.getCreatePath()
      })
    },
    getCreatePath () {
      var path = './create'
      if (this.filterTags) {
        var params = ''
        this.filterTags.forEach((ele) => {
          if (ele.idName) {
            params += ele.idName + '=' + encodeURIComponent(ele.idValue) + '&'
            if (ele.showName) {
              params += ele.showName + '=' + encodeURIComponent(ele.value) + '&'
            }
            if (ele.showType) {
              if (Array.isArray(ele.showType)) {
                ele.showType.forEach((v, idx) => {
                  params += v + '=' + encodeURIComponent(ele.typeValue[idx]) + '&'
                })
              } else {
                params += ele.showType + '=' + encodeURIComponent(ele.typeValue) + '&'
              }
            }
            if (ele.showSubName) {
              params += ele.showSubName + '=' + encodeURIComponent(ele.subNameValue) + '&'
            }
          }
        })
        params = params.slice(0, -1)
        if (params) {
          path += '?' + params
        }
      }
      return path
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss">
  .filter-text {
    margin-top: 15px;
    .el-card__header {
      padding: 10px 15px;
    }
    .el-card__body {
      padding: 8px 18px;
    }
  }
</style>
